import { useMemo } from "react";
import BaseNode from "./BaseNode";
import { ClockIcon } from "lucide-react";
import { Position } from "@xyflow/react";
import { HandleProps, NodeProps } from "./types";
import FormField from "../FormField";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../ui/select";

export default function TimeNode(props: NodeProps) {
  const handles: HandleProps[] = useMemo(
    () => [
      {
        type: "target",
        position: Position.Right,
        id: "output",
      },
    ],
    [],
  );
  return (
    <BaseNode
      title="Time"
      icon={<ClockIcon size={16} />}
      handles={handles}
      {...props}
    >
      <FormField label="Timezone">
        <Select>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="+5.30">Asia/Calcutta | GMT +5.30</SelectItem>
          </SelectContent>
        </Select>
      </FormField>
    </BaseNode>
  );
}
